// Catálogo de permisos — espejo exacto del backend (backend/src/config/permissions.js).
// Si agregás un permiso nuevo, actualizá ambos archivos.
export const PERMISSIONS = {
  DASHBOARD_ACCESS:     'dashboard:access',
  USERS_READ:           'users:read',
  USERS_CREATE_DRIVER:  'users:create:driver',
  USERS_CREATE_ANY:     'users:create:any',
  USERS_EDIT:           'users:edit',
  USERS_DELETE:         'users:delete',
  USERS_RESET_PASSWORD: 'users:reset_password',
  SETTINGS_WRITE:       'settings:write',
};

export const ROLE_PERMISSIONS = {
  SUPERADMIN: Object.values(PERMISSIONS),
  ADMIN: [
    PERMISSIONS.DASHBOARD_ACCESS,
    PERMISSIONS.USERS_READ,
    PERMISSIONS.USERS_CREATE_DRIVER,
    PERMISSIONS.USERS_EDIT,
  ],
  DRIVER: [],
};

export const can = (userRole, permission) =>
  (ROLE_PERMISSIONS[userRole] || []).includes(permission);
